<template>
    <div>
        <form class="ad-search-form" :class="searchbarSize" @submit.stop.prevent="adSearchSubmit">
            <div>
                <label for="city">Ville ou quartier</label>
                <MultipleAutoComplete @changedGPSData="changeGPSData"></MultipleAutoComplete>
            </div>
            <div class="hide-on-small">
                <label for="distance">Rayon</label>
                <select id="distance" name="distance" v-model="adSearchModel.distance">
                    <option v-for="option in distanceOptions" :key="option.value" :value="option.value">{{
                        option.label
                    }}</option>
                </select>
            </div>
            <div>
                <label for="type">Type de bien</label>
                <el-select id="type" name="type" v-model="adSearchModel.type" multiple
                    placeholder="Type de bien"><el-option v-for="option in adTypeOptions" :key="option.value"
                        :value="option.value" :label="option.label"></el-option>
                </el-select>
            </div>
            <div>
                <label for="room-count">Nombre de pièces</label>
                <el-select id="room-count" name="roomCount" v-model="adSearchModel.roomCount" multiple
                    placeholder="Nombre de pièces">
                    <el-option v-for="option in roomCountOptions" :key="option.value" :value="option.value">{{
                        option.label
                    }}</el-option>
                </el-select>
            </div>
            <div class="hide-on-small">
                <label for="surface">Surface</label>
                <el-slider id="surface" name="surface" v-model="adSearchModel.surface" :min="surfaceMin"
                    :max="surfaceMax" :step="5" range :format-tooltip="(v) => v + 'm²'" />
            </div>
            <div class="hide-on-small">
                <label for="budget">Budget</label>
                <el-slider id="budget" name="budget" v-model="adSearchModel.budget" :min="priceMin" :max="priceMax"
                    :step="1000" range :format-tooltip="(v) => parseInt(v).toLocaleString('fr-FR') + '€'" />
            </div>
            <div>
                <input type="submit" class="cg-btn cg-btn-primary" value="Rechercher" />
                <button class="email-alert-button hide-on-small" @click="showAlertModal = true">
                    + Créer une alerte
                </button>
            </div>
        </form>
        <div class="email-alert-modal" v-if="showAlertModal">
            <div v-if="!emailAlertMessage" class="email-alert-modal-content">
                <h4>Créer une alerte avec les critères suivants :</h4>
                <div class="email-alert-criteria">
                    <p v-if="adSearchModel.type && adSearchModel.type.length">
                        {{ '- Type de bien : ' + adSearchModel.type }}
                    </p>
                    <p v-if="adSearchModel.roomCount && adSearchModel.roomCount.length">
                        {{
                            '- Nombre de pièce : ' +
                                adSearchModel.roomCount
                        }}
                    </p>
                    <p v-if="adSearchModel.surface">
                        {{
                            '- Surface : entre ' + adSearchModel.surface[0] + 'm² et ' +
                                adSearchModel.surface[1] + 'm²'
                        }}
                    </p>
                    <p v-if="adSearchModel.budget">
                        {{
                            '- Prix : entre ' + adSearchModel.budget[0] + '€ et ' +
                                adSearchModel.budget[1] + '€'
                        }}
                    </p>
                    <p v-if="adSearchModel.cityNames">{{ '- Villes : ' + adSearchModel.cityNames }}</p>
                    <p v-if="adSearchModel.cityNames">{{ '- Distance : ' + adSearchModel.distance + 'km' }}</p>
                </div>
                <input id="email" type="email" placeholder="Email" required/>
                <button class="cg-btn" @click="showAlertModal = false" :disabled="emailAlertLoading">Annuler</button>
                <button class="cg-btn cg-btn-primary" @click="createAlert"
                    :disabled="emailAlertLoading">Valider</button>
                <div v-if="emailAlertLoading" class="email-alert-loader">
                    <div class="lds-dual-ring"></div>
                </div>
            </div>
            <div v-else class="email-alert-modal-message">
                {{ emailAlertMessage }}
            </div>
        </div>
    </div>
</template>

<script>
import DataApi from '../../dependencies/index'
import Vue from 'vue'
import Element from 'element-ui'

Vue.use(Element)
export default {
    name: 'AdSearchbar',
    components: {
        MultipleAutoComplete: () => import('../../components/MultipleAutoComplete'),
    },
    props: {
        fullSize: {
            type: Boolean
        },
        adSearchModelProp: {
            type: Object,
            default: {
                type: null,
                roomCount: null,
                surface: null,
                coordinates: null,
                distance: '20',
                budget: null
            }
        }
    },
    emits: ['submit'],
    data() {
        return {
            priceMin: 0,
            priceMax: 1500000,
            surfaceMin: 0,
            surfaceMax: 800,
            adSearchModel: this.adSearchModelProp,
            adTypeOptions: [
                { value: 'Maison / Villa', label: 'Maison / Villa' },
                { value: 'Appartement', label: 'Appartement' },
                { value: 'Terrain', label: 'Terrain' },
                { value: 'Commerce', label: 'Commerce' },
                { value: 'Bureau / Local commercial', label: 'Bureau / Local commercial' },
                { value: 'Parking', label: 'Parking' },
                { value: 'Immeuble', label: 'Immeuble' },
                { value: 'Hangar', label: 'Hangar' },
                { value: 'Hôtel particulier', label: 'Hôtel particulier' },
                { value: 'Droit au bail', label: 'Droit au bail' },
                { value: 'Divers', label: 'Divers' }
            ],
            roomCountOptions: [
                { value: '1', label: '1' },
                { value: '2', label: '2' },
                { value: '3', label: '3' },
                { value: '4', label: '4' },
                { value: '5', label: '5' },
                { value: '6', label: '6' },
                { value: '7', label: '7' },
                { value: '8', label: '8' }
            ],
            distanceOptions: [
                { value: '5', label: '5' },
                { value: '10', label: '10' },
                { value: '20', label: '20' },
                { value: '50', label: '50' }
            ],
            showAlertModal: false,
            alertEmailMessage: null,
            emailAlertLoading: false
        }
    },
    methods: {
        changeGPSData(coordinates, cityNames) {
            this.adSearchModel.coordinates = coordinates
            this.adSearchModel.cityNames = cityNames
        },
        adSearchSubmit() {
            let searchData = { ...this.adSearchModel }
            if (this.adSearchModel.budget && this.adSearchModel.budget[0] === this.priceMin
                && this.adSearchModel.budget[1] === this.priceMax) {
                searchData.budget = null
            }
            if (this.adSearchModel.surface && this.adSearchModel.surface[0] === this.surfaceMin
                && this.adSearchModel.surface[1] === this.surfaceMax) {
                searchData.surface = null
            }
            this.$emit('submit', searchData)
        },
        async createAlert() {
            if (!document.getElementById('email').reportValidity()) {
                return
            }
            this.emailAlertLoading = true
            let searchData = { ...this.adSearchModel }
            console.log(searchData)
            const options = {
                apiUrl: this.$apiUrl,
                databaseName: this.$databaseName,
                token: await this.$getMainToken()
            }
            const request = 'type: ' + searchData.type +
                ' nbrPieces: ' + searchData.roomCount +
                ' surface: ' + searchData.surface +
                ' rayon: ' + searchData.distance +
                ' budget: ' + searchData.budget +
                ' villes: ' + searchData.cityNames
            const demandeToSend = {
                email: this.email,
                telephone: '',
                adresse: '',
                codePostal: '',
                ville: '',
                pays: '',
                questions: request,
                rgpd: '',
                type: 'alerte',
                destinataire: 'ti'
            }
            const dataApi = new DataApi(options)
            dataApi.createRecord('W_DemandeContact', demandeToSend,
                [{
                    name: 'validerFormulaire',
                    type: 'postrequest'
                }])
                .then((response) => {
                    this.emailAlertLoading = false
                    this.emailAlertMessage = 'La demande a bien été envoyée.'
                    setTimeout(() => {
                        this.showAlertModal = false
                        this.emailAlertMessage = null
                    }, 5000)
                })
                .catch((error) => {
                    this.emailAlertLoading = false
                    console.log(error)
                    this.emailAlertMessage = 'La demande n\'a pas pu être enregistrée, veuillez reéssayer plus tard'
                    setTimeout(() => {
                        this.showAlertModal = false
                        this.emailAlertMessage = null
                    }, 5000)
                })

        }
    },
    computed: {
        searchbarSize() {
            return this.fullSize ? 'ad-search-form-full' : 'ad-search-form-small'
        }
    }
}
</script>

<style lang="scss">
.ad-search-form {
    background: white;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-radius: 8px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    padding: 11px 16px;

    input {
        border: none;
        border-bottom: solid 1px #ddd;
        margin: 4px 10px 4px 10px;
        height: 46px;
        display: block;
        max-width: 170px;

    }

    .el-input.is-focus .el-input__inner {
        border-color: var(--color-primary) !important;
    }

    .el-select {
        margin: 0 !important;
    }

    .el-select__input {
        border: none;
    }

    select {
        border: none;
        border-bottom: solid 1px #ddd;
        background: none;
        height: 46px;
        margin: 4px 10px 4px 10px;
    }

    select,
    option {
        font-weight: 600;
        font-size: 13px;
    }

    input,
    label,
    select {
        margin: 0;
    }

    input,
    select {
        height: 33px;
    }

    label {
        display: block;
        color: hsla(0, 0%, 0%, 0.5);
        font-size: var(--font-size-small);
        font-weight: 500;
    }

    &>div {
        margin: 0 8px;
    }

    .cg-btn {
        height: 50px;
        width: 250px;
    }

    .email-alert-button {
        background: none;
        color: var(--color-primary);
        border: none;
        font-weight: 600;
        font-size: var(--font-size-small);
    }

    .el-slider {
        height: 33px;
        width: 125px;
        margin: 0 5px;

        .el-slider__runway {
            background-color: #ddd;

            .el-slider__bar,
            .el-slider__button {
                background-color: var(--color-primary);
                border: none;
            }
        }

        .el-slider__runway,
        .el-slider__bar {
            height: 4px;
        }

        .el-slider__button {
            height: 16px;
            width: 16px;
        }

        .el-slider__button-wrapper {
            top: -16px;
        }
    }

    .el-select {
        align-items: center;
        display: flex;
    }
}

.ad-search-form-full {
    align-items: flex-start;

    .submit {
        width: 150px;
    }
}

.ad-search-form-small {
    .hide-on-small {
        display: none;
    }

    label {
        display: none;
    }
}

.email-alert-modal {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.192);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1002;

    .email-alert-modal-content {
        background: #fff;
        border-radius: 8px;
        box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        padding: 24px;

        p,
        input {
            margin: 8px;
        }

        input {
            border: none;
            border-bottom: solid 1px #ddd;
            height: 46px;
        }

        button {
            margin: 8px;
        }
    }

    .email-alert-modal-message {
        background: #fff;
        border-radius: 8px;
        box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.2);
        padding: 24px;
    }

    .email-alert-loader {
        position: absolute;
        top: calc(50% - 40px);
        left: calc(50% - 40px);

        .lds-dual-ring {
            display: inline-block;
            width: 80px;
            height: 80px;
        }

        .lds-dual-ring:after {
            content: " ";
            display: block;
            width: 64px;
            height: 64px;
            margin: 8px;
            border-radius: 50%;
            border: 6px solid var(--color-primary);
            border-color: var(--color-primary) transparent;
            animation: lds-dual-ring 1.2s linear infinite;
        }

        @keyframes lds-dual-ring {
            0% {
                transform: rotate(0deg);
            }

            100% {
                transform: rotate(360deg);
            }
        }
    }
}
</style>